import { createListResponseSchema } from 'src/feature/bite/domain';
import z from 'zod';

export const TerminalListItemSchema = z.object({
  terminalId: z.string(),
  typeID: z.any(),
  statusID: z.any(),
  loyaltyStatusID: z.any(),
  lastTrxDate: z.string(),
});

export const TerminalListSchemaResponse = createListResponseSchema(TerminalListItemSchema.array());

export type TerminalListItem = z.infer<typeof TerminalListItemSchema>;
export type TerminalList = z.infer<typeof TerminalListSchemaResponse.shape.response>;
export type TerminalListResponse = z.infer<typeof TerminalListSchemaResponse>;

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number(),
    childFilters: z.array(z.object({}))
  })
);

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string()
  })
);

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number()
});

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
});

export type ListFilter = z.infer<typeof listFilterSchema>;
